import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function c(n, l) {
  return t(), o("svg", r, [...l[0] || (l[0] = [
    e("g", { "clip-path": "url(#a)" }, [
      e("path", {
        fill: "currentColor",
        d: "M17.46 5c-.06.89-.21 1.76-.45 2.59l1.2 1.2c.41-1.2.67-2.47.76-3.79zM7.6 17.02c-.85.24-1.72.39-2.6.45v1.49c1.32-.09 2.59-.35 3.8-.75zM16.5 3H20c.55 0 1 .45 1 1 0 9.39-7.61 17-17 17-.55 0-1-.45-1-1v-3.49c0-.55.45-1 1-1 1.24 0 2.45-.2 3.57-.57.1-.04.21-.05.31-.05.26 0 .51.1.71.29l2.2 2.2c2.83-1.45 5.15-3.76 6.59-6.59l-2.2-2.2c-.28-.28-.36-.67-.25-1.02.37-1.12.57-2.32.57-3.57 0-.55.45-1 1-1"
      })
    ], -1),
    e("defs", null, [
      e("clipPath", { id: "a" }, [
        e("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])]);
}
const p = { render: c };
export {
  p as default,
  c as render
};
